import { makeStyles } from '@material-ui/styles';
import { Chip } from '@progress/kendo-react-buttons';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import {
  GridCellProps,
  GridCustomFilterCellProps,
} from '@progress/kendo-react-grid';
import { CommandStatusDropDownFilterCell } from './CommandStatusDropDownFilterCell';
import {
  commandStatusTextMap,
  commandStatusToTypeMap,
  getCommandStatusOptions,
} from '../../utils/textMappings';
import { GetString } from '../StringResourceManager';
import { commandStatusIconMap, useChipStyle } from '../../utils/utils';

export const useStyles = makeStyles({
  root: {
    '& .theme-grid--header': {
      fontSize: '1rem',
      color: '#23496B',
    },
  },
});

export const CommandStatusCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;

  let status: string = commandStatusTextMap(dataItem.CommandStatus);
  let chipStyle: any = useChipStyle(dataItem.CommandStatus);
  if (status) {
    return (
      <td>
        <Chip
          className={chipStyle().root}
          text={GetString(status)}
          svgIcon={commandStatusIconMap(dataItem.CommandStatus)}
        />
      </td>
    );
  }
  return null;
};

export const CommandStatusFilterCell: any = (
  props: GridCustomFilterCellProps
) => (
  <CommandStatusDropDownFilterCell
    {...props}
    data={getCommandStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={commandStatusToTypeMap}
  />
);
